import { render, staticRenderFns } from "./ImsOfferingCutomerDetails.vue?vue&type=template&id=8bc512dc&"
import script from "./ImsOfferingCutomerDetails.vue?vue&type=script&lang=js&"
export * from "./ImsOfferingCutomerDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports